export default "__VITE_ASSET__dc4b202d__"